import type { GalleryFileEntry } from '../types/moderation';

function getCdnDomain(): string {
  return (import.meta.env.VITE_CDN_DOMAIN as string) || '';
}

export function getMediaUrl(key: string): string {
  if (!key) return '';
  const cleanKey = key.startsWith('/') ? key.slice(1) : key;
  return `https://${getCdnDomain()}/${cleanKey}`;
}

export function getProcessedUrl(file: GalleryFileEntry): string {
  return getMediaUrl(file.processedKey);
}

export function getThumbnailUrl(
  file: GalleryFileEntry,
  size: 'sm' | 'md' | 'lg' = 'md',
): string {
  const thumbs = file.thumbnailKeys || [];
  if (thumbs.length === 0) {
    return getProcessedUrl(file);
  }
  // Thumbnails are produced small → large. Pick by index.
  let index: number;
  if (size === 'sm') {
    index = 0;
  } else if (size === 'lg') {
    index = thumbs.length - 1;
  } else {
    index = Math.floor(thumbs.length / 2);
    if (index >= thumbs.length) index = thumbs.length - 1;
  }
  return getMediaUrl(thumbs[index]);
}

export function formatBytes(bytes: number): string {
  if (!Number.isFinite(bytes) || bytes <= 0) return '0 B';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  if (bytes < 1024 * 1024 * 1024)
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  return `${(bytes / (1024 * 1024 * 1024)).toFixed(1)} GB`;
}
